<template>
<div class="popup" v-show="isShow">
    <upgradeVipInnerTrafficDialog v-if="isVIP&&!isIns"></upgradeVipInnerTrafficDialog>
    <div class="content free_to_vip_popup" v-if="!isVIP">
        <!-- 标题 -->
        <div class="popup_title">
            <div class="popup_title_bg"></div>
            <div class="popup_title_content">
                <div class="popup_title_main">{{ title }}</div>
                <div class="popup_title_sub">{{$t('language.paySystem.freePlanPopup.desc')}}</div>
                <div class="popup_title_close" @click="isShow=!isShow"></div>
            </div>
        </div>
        <!-- 内容 -->
        <div class="popup_content">
            <div class="popup_content_item popup_content_item_head">
                <div class="popup_content_item1">
                    <div class="popup_content_item_sub">{{$t('language.paySystem.freePlanPopup.itemTitle_th')}}</div>
                </div>
                <div class="popup_content_item2">
                    <div class="popup_content_item_sub1">{{$t('language.paySystem.freePlanPopup.itemValue_cur')}}</div>
                    <div class="popup_content_item_sub2">{{$t('language.paySystem.freePlanPopup.itemValue_free')}}</div>
                </div>
                <div class="popup_content_item3">
                    <div class="popup_content_item_sub1">{{$t('language.paySystem.freePlanPopup.itemValue_upgrade')}}</div>
                    <div class="popup_content_item_sub2">{{$t('language.paySystem.freePlanPopup.itemvalue_premium')}}</div>
                </div>
            </div>
            <div class="popup_content_item" :class="curItem=='traffic'?'select':''">
                <div class="popup_content_item1">{{$t('language.paySystem.freePlanPopup.itemTitle_traffic')}}</div>
                <div class="popup_content_item2">{{$t('language.paySystem.freePlanPopup.itemvalue_5gb')}}</div>
                <div class="popup_content_item3">{{$t('language.paySystem.freePlanPopup.itemvalue_maxUnlimited')}}</div>
            </div>
            <div class="popup_content_item" :class="curItem=='pdf'?'select':''">
                <div class="popup_content_item1">{{$t('language.paySystem.freePlanPopup.itemTitle_pdf')}}</div>
                <div class="popup_content_item2">{{$t('language.paySystem.freePlanPopup.itemvalue_50emails')}}</div>
                <div class="popup_content_item3">{{$t('language.paySystem.freePlanPopup.itemvalue_unlimited')}}</div>
            </div>
            <div class="popup_content_item" :class="curItem=='modes'?'select':''">
                <div class="popup_content_item1">{{$t('language.paySystem.freePlanPopup.itemTitle_modes')}}</div>
                <div class="popup_content_item2">4</div>
                <div class="popup_content_item3">10</div>
            </div>
            <div class="popup_content_item" :class="curItem=='remote'?'select':''">
                <div class="popup_content_item1">{{$t('language.paySystem.freePlanPopup.itemTitle_remote')}}</div>
                <div class="popup_content_item2">1</div>
                <div class="popup_content_item3">5</div>
            </div>
            <div class="popup_content_item" :class="curItem=='subtasks'?'select':''">
                <div class="popup_content_item1">{{$t('language.paySystem.freePlanPopup.itemTitle_subtasks')}}</div>
                <div class="popup_content_item2">3</div>
                <div class="popup_content_item3">1000</div>
            </div>
            <div class="popup_content_item" :class="curItem=='scheduled'?'select':''">
                <div class="popup_content_item1">{{$t('language.paySystem.freePlanPopup.itemTitle_scheduled')}}</div>
                <div class="popup_content_item2"><img src="../../../assets/images/imageSaver/upgradeSupportNo.svg"></div>
                <div class="popup_content_item3"><img src="../../../assets/images/imageSaver/upgradeSupportYes.svg"></div>
            </div>
            <div class="popup_content_item" :class="curItem=='speed'?'select':''">
                <div class="popup_content_item1">{{$t('language.paySystem.freePlanPopup.itemTitle_speed')}}</div>
                <div class="popup_content_item2">
                    <img src="../../../assets/images/imageSaver/upgradeSupportSpeedGrey.svg">
                </div>
                <div class="popup_content_item3">
                    <img src="../../../assets/images/imageSaver/upgradeSupportSpeedOrange.svg">
                    <img src="../../../assets/images/imageSaver/upgradeSupportSpeedOrange.svg">
                    <img src="../../../assets/images/imageSaver/upgradeSupportSpeedOrange.svg">
                    <img src="../../../assets/images/imageSaver/upgradeSupportSpeedOrange.svg">
                    <img src="../../../assets/images/imageSaver/upgradeSupportSpeedOrange.svg">
                </div>
            </div>
            <div class="popup_content_item" :class="curItem=='sync'?'select':''">
                <div class="popup_content_item1">{{$t('language.paySystem.freePlanPopup.itemTitle_sync')}}</div>
                <div class="popup_content_item2">1</div>
                <div class="popup_content_item3">2</div>
            </div>
            <div class="popup_content_item" :class="curItem=='real'?'select':''">
                <div class="popup_content_item1">{{$t('language.paySystem.freePlanPopup.itemTitle_real')}}</div>
                <div class="popup_content_item2">1</div>
                <div class="popup_content_item3">2</div>
            </div>
            <div class="popup_content_item" :class="curItem=='filter'?'select':''">
                <div class="popup_content_item1">{{$t('language.paySystem.freePlanPopup.itemTitle_filter')}}</div>
                <div class="popup_content_item2"><img src="../../../assets/images/imageSaver/upgradeSupportNo.svg"></div>
                <div class="popup_content_item3"><img src="../../../assets/images/imageSaver/upgradeSupportYes.svg"></div>
            </div>
            <div class="popup_content_item">
                <div class="popup_content_item1">{{$t('language.paySystem.freePlanPopup.itemTitle_tran')}}</div>
                <div class="popup_content_item2"><img src="../../../assets/images/imageSaver/upgradeSupportNo.svg"></div>
                <div class="popup_content_item3"><img src="../../../assets/images/imageSaver/upgradeSupportYes.svg"></div>
            </div>
            <div class="popup_content_item">
                <div class="popup_content_item1">{{$t('language.paySystem.freePlanPopup.itemTitle_customer')}}</div>
                <div class="popup_content_item2"><img src="../../../assets/images/imageSaver/upgradeSupportNo.svg"></div>
                <div class="popup_content_item3"><img src="../../../assets/images/imageSaver/upgradeSupportYes.svg"></div>
            </div>
             <div class="popup_content_item">
                <div class="popup_content_item1">{{$t('language.paySystem.freePlanPopup.itemTitle_watermark')}}</div>
                <div class="popup_content_item2"><img src="../../../assets/images/imageSaver/upgradeSupportNo.svg"></div>
                <div class="popup_content_item3"><img src="../../../assets/images/imageSaver/upgradeSupportYes.svg"></div>
            </div>
        </div>
        <!-- 按钮 -->
        <div class="popup_button_box">
            <div class="popup_button" @click="switchToPay">
                <img src="../../../assets/images/imageSaver/upgradeCar.svg">
                <span>{{$t('language.paySystem.freePlanPopup.button')}}</span>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import taskListUtils from "@/js/workspace/task_list_util.js";
import upgradeVipInnerTrafficDialog from "@/components/popup/upgrade_popups/upgrade_account_vip_inner_traffic_popup";
export default {
    name: "upgradeNewDialog",
    components: {
        upgradeVipInnerTrafficDialog,
    },
    data: function () {
        return {
            // 是否显示弹窗
            isShow: false,
            // 当前选中项
            curItem: '',
            // 主标题
            title: 'Oops！',
            // 是否是VIP
            isVIP: false,
            // 是否是Ins
            isIns: false,
        }
    },
    methods: {
        // 跳转到付费
        switchToPay() {
            this.isShow = false;
            commonUtils.switchToPay();
        },
    }
}
</script>

<style scoped>
/* 小屏小弹窗 */
@media (max-width: 1920px) {
    .free_to_vip_popup {
        transform: scale(0.8);
    }
}
/* 外框 */
.content {
    width: 1000px;
    height: 926px;
    border: none;
    border-radius: 8px;
    background: #FFFFFF;
    box-shadow: 0px 10px 10px 0px rgba(87, 94, 136, 0.3);
    font-family: Arial, "Microsoft YaHei", 微软雅黑;
    overflow: hidden;
}
/* 标题框 */
.popup_title {
    height: 129px;
    position: relative;
}
/* 标题背景 */
.popup_title_bg {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    transform: rotate(180deg);
    background-color: #3F4A8D;
    background-image: url("../../../assets/images/imageSaver/upgradePopupBg.png");
    background-blend-mode: overlay;
    background-position: -1px -480px;
    background-size: 1002px 900px;
}
/* 标题内容 */
.popup_title_content {
    width: 100%;
    height: 100%;
    text-align: center;
    position: absolute;
    z-index: 2;
    left: 0;
    top: 0;
}
/* 主标题 */
.popup_title_main {
    margin-top: 34.5px;
    height: 32px;
    line-height: 32px;
    font-size: 28px;
    font-weight: bold;
    color: #FFFFFF;
}
/* 副标题 */
.popup_title_sub {
    margin-top: 10px;
    height: 18px;
    line-height: 18px;
    font-size: 16px;
    font-weight: normal;
    color: #FFFFFF;
}
/* 关闭 */
.popup_title_close {
    width: 30px;
    height: 30px;
    position: absolute;
    z-index: 1;
    right: 10px;
    top: 10px;
    background-image: url("../../../assets/images/imageSaver/upgradeClose.svg");
    cursor: pointer;
}
.popup_title_close:hover {
    background-image: url("../../../assets/images/imageSaver/upgradeCloseHover.svg");
}
.popup_title_close:active {
    background-image: url("../../../assets/images/imageSaver/upgradeCloseActive.svg");
}
/* 主要内容 */
.popup_content {
    padding: 20px;
}
/* 一行，动作或选中 */
.popup_content_item.select,
.popup_content_item:hover {
    background-color: rgba(255, 108, 25, 0.05);
}
/* 高度塌陷 */
.popup_content_item::after {
    content: "";
    display: block;
    clear: both;
}
/* 第1列 */
.popup_content_item1 {
    box-sizing: border-box;
    text-indent: 16px;
    width: 460px;
    height: 44px;
    line-height: 44px;
    float: left;
}
/* 选中情况下，第1列 */
.popup_content_item.select>.popup_content_item1 {
    border-left: 2px solid #FF6C19;
    color: #FF6C19;
}
/* 第2列 */
.popup_content_item2 {
    text-align: center;
    width: 250px;
    height: 44px;
    line-height: 44px;
    float: left;
}
/* 第3列 */
.popup_content_item3 {
    text-align: center;
    width: 250px;
    height: 44px;
    line-height: 44px;
    float: left;
}
/* 标题行 */
.popup_content_item_head:hover {
    background-color: transparent;
}
/* 标题行，第1列 */
.popup_content_item_head>.popup_content_item1 {
    background: #F2F7FE;
    height: 80px;
}
/* 标题行，第2列 */
.popup_content_item_head>.popup_content_item2 {
    background: #F2F7FE;
    height: 80px;
}
/* 标题行，第3列 */
.popup_content_item_head>.popup_content_item3 {
    background: #FFF1EA;
    height: 80px;
    color: #FF6C19;
}
/* 标题行，第1列，文字 */
.popup_content_item_sub {
    height: 80px;
    line-height: 80px;
    font-size: 20px;
    font-weight: bold;
}
/* 标题行，第2,3列，小字 */
.popup_content_item_sub1 {
    font-size: 14px;
    font-weight: normal;
    height: 40px;
    line-height: 60px;
}
/* 标题行，第2,3列，大字 */
.popup_content_item_sub2 {
    font-size: 20px;
    font-weight: bold;
    height: 40px;
    line-height: 20px;
}
/* 升级按钮外框 */
.popup_button_box {
    padding: 20px 0px;
    text-align: center;
}
/* 升级按钮 */
.popup_button {
    cursor: pointer;
    display: inline-block;
    height: 50px;
    line-height: 50px;
    padding: 0 60px;
    color: #FFF;
    font-size: 16px;
    font-weight: bold;
    background: linear-gradient(176deg, #FFA133 5%, #F58427 80%);
    border-radius: 8px;
    user-select: none;
}
/* 升级按钮，动作 */
.popup_button:hover {
    opacity: 0.9;
}
/* 升级按钮，点击 */
.popup_button:active {
    opacity: 0.8;
}
/* 升级按钮，垂直对齐 */
.popup_button>* {
    vertical-align: middle;
}
/* 升级按钮，图标间距 */
.popup_button>img {
    margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/upgrade_popups/upgrade_account_new_popup.vue